module.exports = __webpack_public_path__ + "img/p4.15cf73fc.png";